import createShareButton from 'react-share/lib/hocs/createShareButton'
import objectToGetParams from 'react-share/lib/utils/objectToGetParams'

function facebookMessengerLink(url, { appId, redirectUri, to, mobile }) {
  return (
    (mobile ? 'fb-messenger://share' : 'https://www.facebook.com/dialog/send') +
    objectToGetParams({
      link: url,
      redirect_uri: redirectUri || url,
      app_id: appId,
      to
    })
  )
}

const MessengerShareButton = createShareButton(
  'facebookmessenger',
  facebookMessengerLink,
  (props) => ({
    appId: props.appId,
    redirectUri: props.redirectUri,
    to: props.to,
    mobile: props.mobile
  }),
  {
    windowWidth: 1000,
    windowHeight: 820
  }
)

export default MessengerShareButton
